import { useMemo } from 'react';
import { Category, CategoryGroup } from '../types/category';

/**
 * A hook that returns list of categories grouping by categoryName mapped to their extraDimensions
 * @param categoryList list of category objects
 * @returns list of unique Categories
 *
 * Handles categories which contain multiple extraDimensions by creating mapping structure
 * Returns grouped categories where each group contains all affiliated dimensions and categoryIds
 *
 */

const useCategoryGroups = (categoryList?: Category[]) =>
  useMemo(() => {
    const groups: { [key: string]: CategoryGroup } = {};

    categoryList?.forEach((category) => {
      // map categoryName to new CategoryGroup if it does not exist in map
      if (!groups[category.categoryName]) {
        groups[category.categoryName] = {
          categoryName: category.categoryName,
          extraDimensions: [],
          categoryIds: {},
        };
      }
      // create mapping from categoryName to all extraDimensions affiliated with Category
      if (category.extraDimensions && category.extraDimensions.length > 0) {
        category.extraDimensions.forEach((dimension) => {
          if (!groups[category.categoryName].extraDimensions.includes(dimension)) {
            groups[category.categoryName].extraDimensions.push(dimension);
          }
          groups[category.categoryName].categoryIds[dimension] = category.categoryId;
        });
      } else {
        groups[category.categoryName].categoryIds[''] = category.categoryId;
      }
    });

    return groups;
  }, [categoryList]);

export default useCategoryGroups;
